import Section, {html, css} from './_section'

customElements.define('steens-form-section-emergency', class extends Section{

    get title(){ return '🚨 Emergency' }

    // static get styles(){return css`
    //     :host {
    //         display: block;
    //         position:relative;
    //     }
    // `}

    static get listeners(){ return {
        model: {'change:dob change:session': 'update'}
    }}

    renderControls(){return html`
        <p>
            In emergency, please list the name, address, and phone number of the person we should contact
        </p>

        <check-box key="parent_as_emerg" type="switch" ?hidden=${this.model?.isAdult}
            label="Same as parent/guardian"></check-box>
        
        <br><br>

        <div class="grid-2">
            <form-control material="filled" key="emerg_name" label="Name">
                <input slot="control" type="text">
            </form-control>

            <form-control material="filled" key="emerg_relationship" label="Relationship">
                <input slot="control" type="text">
            </form-control>

            <form-control material="filled" key="emerg_address" label="Address" style="grid-column:1/-1">
                <input slot="control" type="text">
            </form-control>

            <form-control material="filled" key="emerg_phone" label="Phone">
                <input slot="control" type="tel">
            </form-control>

            <form-control material="filled" key="emerg_cell" label="Cell Phone">
                <input slot="control" type="tel">
            </form-control>
        </div>
    `}

})